module.exports = __webpack_public_path__ + "static/img/yunyingkuangjia.b1fb78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/yunyingkuangjia.png
// module id = 8bK5
// module chunks = 1